import React from 'react'
import PropTypes from 'prop-types'
import { Spin } from 'antd'

import { StyledContent, StyledLayout } from './styled'

const FullScreenLoader = ({ loading = true, children }) => (
  <StyledLayout>
    <StyledContent>
      <Spin size="large" spinning={loading} data-test="fullScreenLoading">
        {children}
      </Spin>
    </StyledContent>
  </StyledLayout>
)

FullScreenLoader.propTypes = {
  loading: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
}

export default FullScreenLoader
